<template>
  <footer class="app-footer">
    <div class="container footer-content">
      <p>AlfaCaseBot</p>
      <p>ИИ-тренажер для практики бизнес-кейсов</p>
      <router-link class="footer-help" to="/help">Помощь</router-link>
      <p class="footer-disclaimer">
        AlfaCaseBot — учебный проект. Не является официальным продуктом Альфа-Банка.
      </p>
    </div>
  </footer>
</template>

<script>
// AppFooter.vue: компонент подвала сайта с краткой информацией о продукте.
export default {
  name: 'AppFooter',
}
</script>

<style scoped>
.app-footer {
  width: 100%;
  background: #111;
  border-top: 4px solid var(--primary);
  padding: 20px 24px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.footer-content p {
  margin: 0;
  color: #fff;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.footer-content .footer-disclaimer {
  flex-basis: 100%;
  line-height: 1.6;
  letter-spacing: normal;
  text-transform: none;
}
.footer-help {
  color: #fff;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
</style>
